<template>
    <article>
        <a v-if="url" :href="url" target="_blank" rel="noopener noreferrer" class="block">
            <Contents :date="date" :description="description" :title="title" />
        </a>
        <NuxtLink v-else :to="localePath({ name: 'press-release', params: { release: slug } })">
            <Contents :date="date" :description="description" :title="title" />
        </NuxtLink>
    </article>
</template>

<script>
import Contents from './Contents.vue';
export default {
    name: 'PressReleaseCardContents',
    components: {
        Contents,
    },
    props: {
        slug: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: false,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped></style>
